export interface INewsContentData {
	title: string;
	shortText: string;
	longText: string;
}

export const defaultNewsContentData: INewsContentData = {
	title: "",
	shortText: "",
	longText: "",
}

export const FileUploadItems = [
	{
		key: "imageUrl",
		label: "Web Etkinlik Detay",
		dimensions: "1080x663, 1044x601",
		fileSize: "2097152",
		fileSizeText: "2MB",
		format: "JPEG"
	},
	{
		key: "smallImageUrl",
		label: "Web Etkinlik Listesi",
		dimensions: "332x332",
		fileSize: "2097152",
		fileSizeText: "2MB",
		format: "JPEG"
	}
];

export const InputStyle = {
	height: "40px",
	width: "100%",
	marginBottom: "10px",
};

export const labelStyle: React.CSSProperties = {
	padding: 0,
	fontWeight: "normal",
	width: "220px",
	fontSize: "15px",
};